"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Paragraph = exports.LogoWrapper = exports.LabelContainer = exports.Label = exports.Input = exports.Image = exports.FormWrapper = exports.FormContainer = exports.Container = exports.CheckboxParagraph = exports.CheckboxContainer = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
exports.Wrapper = Wrapper;
const Container = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: ${props => props.backgroundColor ?? 'transparent'};
  border: 1px solid ${props => props.borderColor ?? 'black'};
  width: fit-content;
  padding: 20px 40px;
  @media (max-width: ${_breakpoints.BREAKPOINTS.xs}px) {
    width: -webkit-fill-available;
    padding: 20px;
  }
  form {
    width: 100%;
  }
`;
exports.Container = Container;
const FormWrapper = _styledComponents.default.div`
  display: flex;
`;
exports.FormWrapper = FormWrapper;
const FormContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    flex-direction: column;
  }
`;
exports.FormContainer = FormContainer;
const CheckboxContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 25px;
`;
exports.CheckboxContainer = CheckboxContainer;
const LabelContainer = _styledComponents.default.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-width: 250px;
  margin-right: ${props => props.labelMargin ? '40px' : '0'};
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    margin: 25px 0 0 0;
    min-width: unset;
    width: 100%;
  }
`;
exports.LabelContainer = LabelContainer;
const Label = _styledComponents.default.label`
  position: absolute;
  font-family: 'univers-black', sans-serif;
  color: ${props => props.textColor ?? 'black'};
  margin-left: 5px;
  will-change: transform, font-size;
  ${(0, _typography.setFontSizes)({
  xs: '14px',
  sm: '14px',
  lg: '14px'
})}
  ${(0, _typography.setFont)({
  bold: false
})};
`;
exports.Label = Label;
const Input = _styledComponents.default.input`
  background-color: transparent;
  color: ${props => props.textColor ?? 'black'};
  font-family: 'univers-black', sans-serif;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${props => props.borderColor ?? 'black'};
  padding: 5px;
  ${(0, _typography.setFontSizes)({
  xs: '13px',
  sm: '14px',
  lg: '14px'
})}
  ${(0, _typography.setFont)({
  bold: false
})};
  ${props => props.checkbox && `
    margin: 0 15px 0 0;
    width: 20px;
    height: 20px;
    appearance: none;
    border: 1px solid ${props.borderColor ?? 'white'};
    border-radius: 0;
    outline: none;
    &:checked {
      background-color: ${props.buttonColor ?? 'white'}; 
      border-color: ${props.buttonColor ?? 'white'};
    }
    &:checked::before {
      content: 'X';
      display: block;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: ${props.buttonTextColor ?? 'black'};
      font-size: 10px;
    }
  `}
`;
exports.Input = Input;
const Paragraph = _styledComponents.default.p`
  font-family: 'univers-black', sans-serif;
  color: ${props => props.textColor ?? 'black'};
  ${(0, _typography.setFontSizes)({
  xs: '14px',
  sm: '14px',
  lg: '14px'
})}
  ${props => (0, _typography.setFont)({
  bold: props.bold
})};
  a {
    color: ${props => props.textColor ?? 'black'} !important;
    text-decoration: underline;
  }
`;
exports.Paragraph = Paragraph;
const CheckboxParagraph = (0, _styledComponents.default)(Paragraph)`
  ${(0, _typography.setFontSizes)({
  xs: '12px',
  sm: '12px',
  lg: '12px'
})};
  margin: 0;
  max-width: 500px;
`;
exports.CheckboxParagraph = CheckboxParagraph;
const Button = _styledComponents.default.button`
  background-color: ${props => props.buttonColor ?? 'white'};
  color: ${props => props.buttonTextColor ?? 'black'};
  border: 1px solid ${props => props.buttonColor ?? 'white'};
  font-family: 'univers-black', sans-serif;
  padding: 5px 10px;
  margin-top: 40px;
  width: 100%;
  cursor: pointer;
  ${(0, _typography.setFontSizes)({
  xs: '13px',
  sm: '14px',
  lg: '14px'
})}
  ${(0, _typography.setFont)({
  bold: false
})};
  &:hover {
    filter: invert(100%);
    border-color: ${props => props.buttonTextColor ?? 'black'};
  }
`;
exports.Button = Button;
const LogoWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;
exports.LogoWrapper = LogoWrapper;
const Image = _styledComponents.default.img`
  max-width: 100px;
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    max-width: 140px;
  }
  @media (min-width: ${_breakpoints.BREAKPOINTS.md}px) {
    max-width: 160px;
  }
`;
exports.Image = Image;
//# sourceMappingURL=styles.js.map